export default __webpack_public_path__ + "static/media/how-to-invest-build-portfolio.3abfe25e.png";